export const workDatas = [

  {
    id: 0,
    client: "Royal Time",
    icon: require("../assets/Royal-Time_logo.svg").default,
    title: "Graphic Designer Intern",
    date: "2013",
    position: "Royal Time",
    location: "Varese, Italy",
    graphicTools: [
      "Adobe Photoshop",
      "Adobe Illustrator",
    ],
    codingTools: [
    ],
    content: [
      "Cut my teeth in graphic design with a six-month internship at Royal Time, a dynamic advertising agency. Contributed to high-energy advertising campaigns for regional entertainment events, honing social media management skills by maintaining engaging online narratives for multiple Facebook accounts.",
      <br key={0} />, <br key={1} />,
      "This formative period was crucial in sharpening my design capabilities and deepening my understanding of the ad industry, all while collaborating with a seasoned team to deliver client success.",
    ],
  },

  {
    id: 1,
    client: "Pixxa Ltd",
    title: "Product Designer",
    icon: require("../assets/Pixxa_Logo.svg").default,
    position: "Pixxa Ltd",
    date: "2015-2016",
    location: "London, UK",
    graphicTools: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingTools: [
    ],
    content: [
      "As the lead Product Designer for Pixxa Ltd in London, I shaped and upheld their visual identity, producing a suite of print and digital assets from banners to business cards. I also spearheaded their social media, growing a lively online community with engaging content and promotions. My design finesse extended to in-shop aesthetics, with custom posters and vinyl stickers that enhanced the customer experience.",
      <br key={0}/>, <br key={1}/>, 
      "My efforts fortified Pixxa's brand, boosting engagement and fostering loyalty.",
    ],
  },

  {
    id: 2,
    client: "Overmind",
    title: "Graphic Designer",
    icon: require("../assets/Overmind_Logo.png"),
    position: "Overmind",
    date: "2016",
    location: "Milan, Italy",
    graphicTools: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
    ],
    codingTools: [
    ],
    content:[
      "At Overmind, I enhanced their party night events with expert marketing and graphic design, crafting logos, flyers, and gadgets that resonated with each event's vibe.",
      <br key={0} />, <br key={1} />,
      "I tuned into the team's vision to deliver captivating designs, ensuring client goals were met with creativity and precision. My efforts helped bolster Overmind's brand, drawing greater attendance and engagement. Proudly, my role there refined my graphic design and marketing prowess within a vibrant team setting."
  ]},

  {
    id: 3,
    client: "Bymark",
    title: "UI Designer",
    icon: require("../assets/Bymark_Logo.svg").default,
    position: "Bymark",
    date: "High School",
    location: "Milan, Italy",
    graphicTools: [
      "Adobe Illustrator",
      "Adobe Photoshop",
      "Sketch",
    ],
    codingTools: [
    ],
    content:[
      "Collaborated with Bymark as a designer, creating visually appealing and user-friendly layouts, interfaces, and elements for diverse devices and functions. Focused on enhancing user experience, I closely collaborated with the Bymark team to meet unique project needs.",
      <br key={0} />, <br key={1} />,
      "My expertise spans desktop and mobile applications, showcasing creativity and attention to detail. Grateful for the opportunity, my work with Bymark enriched my portfolio, sharpened my design skills, and deepened my expertise in UI/UX Design."
  ]},
  {
    id: 4,
    client: "European Aerosols",
    title: "Product Designer",
    icon: require("../assets/EA.svg").default,
    position: "European Aerosols",
    date: "2015 - 2016",
    location: "South-Europe",
    graphicTools: [
      "Adobe Illustrator",
      "Adobe InDesign",
      "Adobe Photoshop",
      "Adobe After Effects",
      "Procreate",
      "Sketch",
    ],
    codingTools: [
      "HTML",
      "CSS"
    ],
    content:[
      "Experienced Product Designer at European Aerosols, a leading spray can production company in Germany and the Netherlands. Managed company image across Europe, handling diverse tasks such as designing product labels, catalogues, and marketing materials. Ensured high-quality printed materials, collaborated with printers, and contributed to store displays and interior designs. Maintained corporate consistency, adhered to marketing guidelines, and enhanced brand recognition throughout South-Europe Area."
    ]},
  {
    id: 5,
    client: "2000 Network",
    title: "Photo Retoucher",
    icon: require("../assets/2000Network_Logo.png"),
    position: "2000 Network",
    date: "2016 - 2023",
    location: "Milan, Italy",
    institute: "",
    graphicTools: [
      "Adobe Photoshop",
    ],
    codingTools: [
    ],
    content:[
      "As a Photo Retoucher at 2000 Network, I meticulously enhanced images for our website, focusing on perfect lighting and highlighting the essence of our key products. The result? Delighted customers seamlessly integrating these images into their e-commerce platforms, driving significant sales.",
      <br key={0}/>, <br key={0}/>,
      "Our innovative approach not only satisfied but surpassed customer expectations, positioning 2000 Network as an industry leader, setting new standards.",
    ]
  },
  {
    id: 6,
    client: "Avid Technology",
    title: "Junior Software Developer",
    icon: require("../assets/Avid_Logo.png"),
    position: "Avid Technology",
    date: "2024 - Now",
    location: "Milan, Italy",
    graphicTools: [
      "Figma"
    ],
    codingTools: [
      "HTML",
      "CSS",
      "Javascript",
      "React",
      "Vue",
      "NodeJS",
      "Python",
      "Ansible",
      "Docker",
      "Kubernetes",
      "Tailwind",
      "Linux",
    ],
    content:[
      "As a Junior Software Developer at Avid Technology, I focus on implementing innovative software and websites with a full-stack perspective, ensuring each project benefits from a unique blend of technical proficiency and design finesse.",
      <br key={0} />, <br key={1} />,
      "Part of a dynamic development team, my role is pivotal in creating digital solutions that resonate globally, enhancing the brand's digital footprint with functionality and visual appeal.",
      ]
  },
  {
    id: 7,
    client: "",
    title: "Freelance",
    icon: require("../assets/Stondato.png"),
    position: "",
    date: "2023 - Now",
    location: "Milan, Italy",
    graphicTools: "",
    codingTools: "",
    content:[
      "Driven by a fervent zeal for design, I transitioned from a seasoned Freelance Graphic Designer to a Software Developer. My foundation in Graphic Design has sharpened my artistic flair and meticulous attention to detail.",
      <br key={0} />, <br key={1} />,
      "Currently, I'm plunging into the dynamic realm of Coding, armed with a repertoire of cutting-edge Front-End capabilities. My appetite for challenges and unwavering commitment to growth propel me forward; I'm determined to excel and lead in every new arena I venture into.",
      <br key={2} />, <br key={3} />,
      "Beyond my current pursuits, I'm continuously enhancing my skills. Together, let's push boundaries and craft innovative solutions!",
    ]
  },
];